module.exports = __webpack_public_path__ + "assets/img/6.7db18869.png";